<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
<!--        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>-->
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">关 闭</van-button>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="指令单预览" name="1">
        <van-field v-model="inputForm.copyInfo" label="抄送情况" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="height: 750px; padding: 5px 0">
          <iframe ref="reportIframe" :src="iframeUrl" width="100%" height="100%" frameborder="0"></iframe>
        </div>
      </van-collapse-item>
    </van-collapse>

  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
export default {
  name: "ItsDispatch",
  data(){
    return {
      activeNames: ['1'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_base_cold_storage',
      resid: '',
      iframeUrl: ''
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.init(id)
  },
  methods: {
    scaleIframeContent() {
      const iframe = this.$refs.reportIframe;
      if (!iframe) return;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (!iframeDoc) return;

      const contentWidth = iframeDoc.body.scrollWidth;
      const contentHeight = iframeDoc.body.scrollHeight;
      const iframeWidth = iframe.clientWidth;
      const scale = iframeWidth / contentWidth;

      const html = iframeDoc.documentElement;
      html.style.transformOrigin = '0 0';
      html.style.transform = `scale(${scale})`;
      html.style.width = contentWidth + 'px';

      iframe.style.height = contentHeight * scale + 'px';
    },
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById( id, '/its/dispatch/itsDispatch/queryById').then(({ data }) => {
        this.inputForm = data
        this.resid = data.smartbiResid
        this.initIframe(this.inputForm.linkId, this.resid)
      }).catch(e => {
        console.log(e)
      })
      // this.initIframe()
    },
    initIframe(linkId, resid) {
      let query = []
      query.push(`resid=${resid}`)
      query.push(`paramsInfo=${JSON.stringify([{name: 'id', value: linkId, displayValue: linkId}])}`)
      query.push(`paramDisplay.id=${linkId}`)
      query.push(`user=admin`)
      query.push(`password=jinqiao!1721`)
      query.push(`showheader=false`)
      this.iframeUrl = `/smartbi/vision/openresource.jsp?${query.join('&')}`
      // this.iframeUrl = `/smartbi/vision/openresource.jsp?resid=I8a8048bc0198bc3dbc3d8fc501996ffefe29154d&paramsInfo=[{'name':'id','value':'1963418920443318274','displayValue':'1963418920443318274'}]&user=admin&password=jinqiao!1721&showheader=false`
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
  }
}
</script>

<style scoped>

</style>